import React from "react"
import { Link } from "gatsby"
import { useIntl } from "hooks"
import { hero } from "images"
import {
  ContentPros,
  CallToAction,
  HowItWorks,
  LogoBar,
  Layout,
  StoriesCarousel,
  WhatIsSocialie,
  SEO,
} from "components"
import { routes } from "helpers"
import { colors } from "styles/theme"

export default function Home() {
  const { t } = useIntl()
  return (
    <>
      <SEO description={t("SEO__PageDescription--Home")} lang="en" title="Home" pathname="/" />
      <Layout>
        {/* Hero */}
        <div
          className="pt-10 pb-0 phablet:pt-15 tablet:pt-10 laptop:py-0"
          style={{ background: `linear-gradient(to bottom, ${colors.lightGrey}, ${colors.white})` }}
        >
          <div className="container h-full flex flex-wrap-reverse laptop:flex-no-wrap laptop:items-start">
            <div className="mb-2/12 laptop:mr-1/12 w-full tablet:w-10/12 laptop:w-5/12 laptop:min-w-5/12">
              <div className="mb-1 laptop:mt-20">
                <h1 className="text-h3 leading-h3 tracking-30 tablet:text-h3 tablet:leading-h3 tablet:tracking-30 laptop:text-h1 laptop:leading-h1 laptop:tracking-66 text-body font-serif ">
                  {t("Home__Hero--Heading")}
                </h1>
              </div>
              <div className="mb-6">
                <h6 className="text-darkGrey text-h6 tracking-12 leading-h6 font-black">
                  {t("Home__Hero--Subheading")}
                </h6>
              </div>
              <Link to={routes.requestDemo} className="btn btn-primary">
                {t("Global__RequestDemo")}
              </Link>
            </div>
            <div className="-mt-2/12 -mb-1/12 min-w-180% tablet:-ml-1/12 tablet:min-w-130% tablet:-mb-1/12 laptop:-mb-0 -ml-3/12 tablet:w-full tablet:-mt-1/12 laptop:mt-0 tablet:pt-0 laptop:pt-11 laptop:-ml-1/12 laptop:min-w-8/12">
              <img
                src={hero}
                className="h-auto tablet:max-h-87.5 tablet:w-auto w-full laptop:max-w-full"
                alt="socialie home hero illustration"
              />
            </div>
          </div>
        </div>
        {/* LogoBar */}
        <LogoBar />
        {/* WhatIsSocialie */}
        <WhatIsSocialie />
        {/* How it works */}
        <HowItWorks />
        {/* Carousel */}
        <div id="stories">
          <StoriesCarousel />
        </div>
        {/* Content Pros section */}
        <ContentPros />
        {/* Call to action section */}
        <CallToAction />
      </Layout>
    </>
  )
}
